import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { ConfigurableFormComponent } from '../../../shared/modules/configurable-form/containers/configurable-form/configurable-form.component';
import { OnFieldChanged } from '../../../shared/modules/configurable-form/models/on-field-changed';
import { State } from '../../reducers';
import { getOneClickSelectedOrder } from '../../selectors/one-click-orders.selector';
import { MatDialog } from '@angular/material/dialog';
import { OneClickErrorNoSalesArea } from '../../../one-click-order/actions/one-click-jobsite-sales-area.actions';
import { OneClickUpdateOrderAction } from '@ordersnproducts/modules/one-click-order/actions/one-click-orders.actions';
import { map, switchMap, take } from 'rxjs/operators';
import { getOneClickJobsiteSalesAreas } from '../../../one-click-order/selectors/one-click-jobsite-sales-area.selector';
import { Order } from '@cemex-core/cmx-api';

@Injectable()
export class OneClickUpdateSalesArea implements OnFieldChanged {
  constructor(
    private store: Store<State>,
    private dialog: MatDialog,
  ) {}

  // TODO: WIP CX018GO1905-832
  onFieldChanged(value: string, formGroup: UntypedFormGroup, form: ConfigurableFormComponent): void {
    if (value) {
      this.store
        .select(getOneClickJobsiteSalesAreas)
        .pipe(
          take(1),
          switchMap((jobsiteSalesAreas) =>
            this.store.select(getOneClickSelectedOrder).pipe(
              take(1),
              map((order) => ({ order, jobsiteSalesAreas })),
            ),
          ),
        )
        .subscribe(({ order, jobsiteSalesAreas }) => {
          // FIXME: This is executed a LOT of times. Find a more performant way to do the validation
          if (jobsiteSalesAreas === null || jobsiteSalesAreas === undefined || jobsiteSalesAreas.length === 0) {
            // FIXME: Stop propagating the order to the rest of the field validations
            this.store.dispatch(new OneClickUpdateOrderAction(null));

            // TODO: Disable Submit button
            formGroup.disable();
            // TODO: Close the current one-click order modal OR disable all the fields including the submit button
            this.dialog.closeAll();
            this.store.dispatch(new OneClickErrorNoSalesArea());
          } else {
            const validSalesArea = jobsiteSalesAreas[0].salesArea;
            const modded: Order = { ...order };

            // FIXME: Get all the new updated data from the validSalesArea. Currently the validSalesArea only gets the new salesAreaId
            modded.salesArea = {
              businessLine: validSalesArea.businessLine,
              channelCode: validSalesArea.channelCode,
              countryCode: validSalesArea.countryCode,
              divisionCode: validSalesArea.divisionCode,
              // TODO: Where does this property comes from? Is not present in the salesArea object, only in the order object
              // onLine: validSalesArea
              salesAreaId: validSalesArea.salesAreaId,
              salesOrganizationCode: validSalesArea.salesOrganizationCode,
            };

            this.store.dispatch(new OneClickUpdateOrderAction(modded));
          }
        });
    }
  }
}
